
import { Avatar, Button, Col, Descriptions, Divider, Input, List, Radio, Row, Select, Space, Tag, Tooltip, Typography, Collapse } from 'antd';
import { MinusCircleOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import type { RadioChangeEvent } from 'antd';

import { createElement, ReactElement, useEffect, useState } from 'react';
import { DateFilter } from '../types/types'

import { SignalList } from './SignalList';
import { SignalStream } from './SignalStream';
import { TableOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useIsBigScreen, useIsSmallScreen } from '../app/hooks'

interface SignalBrowserFilterParams {
    // name?: string
    // data_set_id?: string
    symbol?: string
    // showButtons?: boolean
    // addContextColumns?: boolean
    dateFilter: DateFilter
    symbolFilter: string | null
    addButtons?: ReactElement
    reloadData: () => void
    setDateFilter: (date: DateFilter) => void
    setSymbolFilter: (symbol: string) => void
    style?: React.CSSProperties
}

type signalSelection = 'table' | 'stream'

export function SignalBrowserFilter({
    // name,
    // data_set_id,
    symbol,
    // showButtons=true,
    // addContextColumns=false,
    dateFilter,
    symbolFilter,
    addButtons,
    reloadData,
    setDateFilter,
    setSymbolFilter,
    style,
}: SignalBrowserFilterParams) {

    // const [reloadedLast, setReloadedLast] = useState('never');
    // const [dateFilter, setDateFilter] = useState<DateFilter>('30_days');
    // const [symbolFilter, setSymbolFilter] = useState<string | null>(null);
    const [searchOpen, setSearchOpen] = useState<boolean>(false);

    const isSmallScreen = useIsSmallScreen()

    const handleDateFilterSelectChange = (value: DateFilter) => {
        setDateFilter(value)
    }

    const handleDateFilterRadioChange = (e: RadioChangeEvent) => {
        // setLocalDateFilter(e.target.value)
        setDateFilter(e.target.value)
    }

    const onSearch = (value: string) => {
        console.log("onSearch", {value})
        setSymbolFilter(value)
    }

    const toggleSearch = () => {
        setSearchOpen(!searchOpen)
    }

    const genExtra = () => (
        <Button
            type="default"
            onClick={(event) => {
                // If you don't want click extra trigger collapse, you can prevent this:
                event.stopPropagation();
                reloadData()
            }}
            // onClick={reloadData}
            >
                <ReloadOutlined />Reload
        </Button>
        // <SettingOutlined
        //   onClick={(event) => {
        //     // If you don't want click extra trigger collapse, you can prevent this:
        //     event.stopPropagation();
        //   }}
        // />
      );
    const dateFilterOptions = [
        { label: '1d', value: 'today'},
        { label: '7d', value: '7_days'},
        { label: '30d', value: '30_days'},
    ]

    const smallFilters = () => {
        return (
            <div style={style ? style : {}}>
                <Space direction={'horizontal'} >
                    <Button type="default" onClick={reloadData}><ReloadOutlined /></Button>

                    <Radio.Group options={dateFilterOptions} defaultValue={dateFilter} value={dateFilter} optionType="button" onChange={handleDateFilterRadioChange} />

                    {!symbol && (
                        <Button onClick={toggleSearch} type={ searchOpen ? "primary" : "default"}><SearchOutlined /></Button>

                    )}
                    {addButtons && (
                        <>
                            {addButtons}
                        </>
                    )}

                    {/* <Divider type="vertical" />
                    <Radio.Group>
                        <Radio.Button value="positive">Positive</Radio.Button>
                        <Radio.Button value="neutral">Neutral</Radio.Button>
                        <Radio.Button value="negative">Negative</Radio.Button>
                    </Radio.Group> */}
                    {/* <Button type="primary" onClick={clear_click}>Clear</Button> */}
                </Space>

                {searchOpen && (
                    <div>
                        {/* <Divider type="horizontal" /> */}
                        <Input.Search autoFocus placeholder="search..." allowClear onSearch={onSearch} style={{ width: '100%', marginTop: '6px' }} bordered={false} />
                    </div>
                )}
            </div>
            
        )

    }

    const bigFilters = () => {
        return (
            <Space direction={'horizontal'} style={style ? style : {}}>
                {/* <Button type="default" onClick={reloadData}><ReloadOutlined /></Button> */}
                {/* <Button type="default"><ReloadOutlined /></Button> */}

                <Button type="default" onClick={reloadData}><ReloadOutlined /></Button>

                {!isSmallScreen && (
                    <Divider type='vertical' />
                )}
                {/* <Button type="default">Filter</Button> */}
                {/* <Select<DateFilter> style={{ width: 150 }} defaultValue={dateFilter} onChange={handleDateFilterSelectChange}>
    
                    <Select.Option value="today">Today</Select.Option>
                    <Select.Option value="7_days">Last 7 Days</Select.Option>
                    <Select.Option value="30_days">Last 30 Days</Select.Option>
                </Select> */}

                <Radio.Group options={dateFilterOptions} defaultValue={dateFilter} value={dateFilter} optionType="button" onChange={handleDateFilterRadioChange} />

                {!symbol && (
                    <Input.Search placeholder="search..." allowClear onSearch={onSearch} style={{ width: 150 }} />
                )}
                {addButtons && (
                    <>
                        {!isSmallScreen && (
                            <Divider type='vertical' />
                        )}
                        {addButtons}
                    </>
                )}
                {/* <Divider type="vertical" />
                <Radio.Group>
                    <Radio.Button value="positive">Positive</Radio.Button>
                    <Radio.Button value="neutral">Neutral</Radio.Button>
                    <Radio.Button value="negative">Negative</Radio.Button>
                </Radio.Group> */}
                {/* <Button type="primary" onClick={clear_click}>Clear</Button> */}
            </Space>
        )
    }

    return isSmallScreen ? smallFilters() : bigFilters()

}
